import { render, staticRenderFns } from "./SinTdcPF.vue?vue&type=template&id=2f2c5681&scoped=true"
import script from "./SinTdcPF.vue?vue&type=script&lang=js"
export * from "./SinTdcPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c5681",
  null
  
)

export default component.exports